/* tslint:disable */
/* eslint-disable */
export enum CustomerNotificationTypeEnum {
  PlainText = 'PlainText',
  Html = 'Html',
  Payload = 'Payload'
}
